"use client"

import { Badge } from "@repo/ui/components/ui/badge"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/ui/card"
import { motion, useInView } from "framer-motion"
import { useRef } from "react"
import { PRODUCT_HIGHLIGHTS } from "./home-marketing-content"

export function ProductHighlightsSection(): JSX.Element {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  return (
    <section id="highlights" className="bg-background py-16 md:py-20" ref={ref}>
      <div className="container mx-auto flex flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <motion.div
          className="flex flex-col gap-4 text-center"
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Des outils{" "}
            <span className="text-primary">à forte valeur ajoutée</span>
          </h2>
          <p className="mx-auto max-w-2xl text-base text-muted-foreground leading-relaxed">
            Valorisez chaque arbre et pilotez vos espaces boisés avec précision grâce aux
            calculs intégrés à DENDROMAP.
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          {PRODUCT_HIGHLIGHTS.map((highlight, index) => {
            const Icon = highlight.icon
            return (
              <motion.div
                key={highlight.id}
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="h-full border-primary/15 shadow-forest transition-all hover:border-primary/30 hover:shadow-forest-lg">
                  <CardHeader className="gap-4">
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10">
                        <Icon className="size-6 text-primary" aria-hidden />
                      </div>
                      {highlight.badge ? (
                        <Badge variant="secondary" className="shrink-0">
                          {highlight.badge}
                        </Badge>
                      ) : null}
                    </div>
                    <CardTitle className="text-xl leading-snug">{highlight.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                      {highlight.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
